import React from "react";

import { usePermiso } from "components/Permisos/PermisosContext";
import { visibleTiles } from "./menu";
import RenderModule from "./renderModule";

export default function RenderModules({ modules, onSubmenu }) {
  const { allow } = usePermiso();

  return (
    <div
      style={{
        display: "grid",
        gap: "10px",
        gridTemplateColumns: "repeat(auto-fill, 130px)",
        gridAutoRows: "110px",
      }}
    >
      {visibleTiles(modules, allow).map((module, i) => (
        <RenderModule key={`module-${i}`} module={module} onSubmenu={onSubmenu} />
      ))}
    </div>
  );
}
